import "amfe-flexible"
import "babel-polyfill"
import Vue from "vue"
import { Toast, NavBar, Cell, Button } from "vant"
import "./assets/css/var.less"
import "./assets/css/common.less"
import "./assets/css/app.less"
import App from "./App"
import { router } from "./router/index"
import store from "./store"
import VueMixin from "./mixins"// 全局配置方法类
import VueFilter from "./filter"
import Vconsole from 'vconsole';
import VueClick from 'vue-click'

Vue.use(NavBar)
Vue.use(Cell)
Vue.use(Button)
Vue.use(Toast)
Vue.use(VueClick)

Toast.setDefaultOptions({
  duration: 2000,
  overlay: false
})


// production mode disables log and info
if (process.env.NODE_ENV === "production") {
  console.log = () => { };
  console.info = () => { };
}

if (process.env.NODE_ENV != "production") {
  new Vconsole()
}


Vue.mixin(VueMixin)
Object.keys(VueFilter).forEach(function (key) {
  Vue.filter(key, VueFilter[key])
})

Vue.config.warnHandler = function (msg, vm, trace) {
  console.log('捕获全局vue抛出异常：msg == %O, vm == %O, trace == %O', msg, vm, trace);
}

new Vue({
  router,
  store,
  el: "#app",
  render: (h) => h(App),
})
